import { useState } from "react";
import Container from "@mui/material/Container";
import Header from "component/Header/Header";
import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useFormik } from "formik";
import { FormControl, TextField, InputLabel } from "@mui/material";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import MailEnviado from "component/MailEnviado/MailEnviado";
import { recoverPassword } from "component/api";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import Grid from "@mui/material/Grid";
import "./RecuperarContraseña.css";

const RecuperarContraseña = () => {
  const [messageError, setMessageError] = useState(false);
  const [deshabilitar, setDeshabilitar] = useState(false);
  const [error, setError] = useState(false);
  const [messageErrorText, setMessageErrorText] = useState("");

  async function recoverPasswordFunc(cc) {
    await recoverPassword(cc)
      .then((response) => {
        setMailEnviado(true);
      })
      .catch(() => {
        // This used to word the error from the status code: 403 meant the empresa had no email
        // on file, 404 meant the cuenta contrato did not exist. Those two answers were the user
        // enumeration finding — cuenta contrato values are twelve digits, so anyone could walk
        // the range and read back who is an AySA customer and who is not.
        //
        // Recovery now always answers 200, so reaching this handler no longer says anything
        // about the account: the request never completed. Reading err.response.status here
        // would have thrown on exactly that case anyway, since a network error carries no
        // response, and that was the one case left able to reach this code.
        setError(true);
        formik.setFieldError("cuenta", " ");
        setMessageError(true);
        setDeshabilitar(true);
        setMessageErrorText(
          "No pudimos procesar tu solicitud. Volvé a intentar en unos minutos."
        );
      });
  }

  let history = useNavigate();

  const validation = Yup.object().shape({
    cuenta: Yup.string().required("requerido"),
  });
  const formik = useFormik({
    initialValues: {
      cuenta: "",
    },
    validationSchema: validation,
    onSubmit: (values) => {
      const { cuenta } = values;
      recoverPasswordFunc(cuenta);
    },
  });

  const [mailEnviado, setMailEnviado] = useState(false);
  function onChangeCuentaContrato(value) {
    formik.setFieldValue("cuenta", value);
    setMessageError(false);
    setError(false);
    setDeshabilitar(false);
  }
  return (
    <div>
      <Header />

      <div>
        <Container maxWidth="sm">
          <br />
          {mailEnviado === false && (
            <div>
              <Button
                onClick={() => history(-1)}
                startIcon={<ArrowBackIosIcon />}
                style={{
                  marginLeft: "0%",
                  width: "8%",
                  textTransform: "none",
                  backgroundColor: "white",
                  color: "blue",
                }}
              >
                Volver
              </Button>
              <h1>Recuperá tu contraseña</h1>
              <p>
                Ingresando tu número de cuenta podrás generar una nueva
                contraseña para acceder a tu cuenta.
              </p>
              <br />
              <form
                onSubmit={formik.handleSubmit}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <FormControl className="form-control-recuperar-contraseña">
                  <InputLabel
                    style={{ color: error === true ? "red" : "black" }}
                  >
                    Número Cuenta
                  </InputLabel>

                  <TextField
                    className="text-field-recuperar-contraseña"
                    onChange={(event) => {
                      onChangeCuentaContrato(event.target.value);
                    }}
                    style={{ marginBottom: "2%" }}
                    placeholder="00000000000"
                    id="cuenta"
                    name="cuenta"
                    variant="outlined"
                    helperText={formik.errors.cuenta}
                    error={formik.errors.cuenta}
                  />
                </FormControl>

                {messageError === true && (
                  <div
                    style={{
                      backgroundColor: "#F9CDD0",
                      border: "red 1px ridge",
                      width: "80%",

                      marginBottom: "10px",
                    }}
                  >
                    <Grid container sx={{ width: "100%" }}>
                      <Grid size={{ xs: 2 }}>
                        <ErrorRoundedIcon
                          fontSize="large"
                          color="secondary"
                          style={{ marginTop: "25%", marginLeft: "25%" }}
                        />
                      </Grid>
                      <Grid size="grow">
                        <p>{messageErrorText}</p>
                      </Grid>
                    </Grid>
                  </div>
                )}

                <Button
                  variant="contained"
                  type="submit"
                  disabled={deshabilitar}
                  style={{
                    width: "30%",
                    marginLeft: "35%",
                    marginTop: "5%",
                    textTransform: "none",
                    color: "white",
                    backgroundColor:
                      deshabilitar === true ? "#B1B0AF" : "#009BDB",
                  }}
                >
                  Enviar
                </Button>
              </form>
            </div>
          )}
          {mailEnviado === true && (
            <div>
              <MailEnviado words={"recuperar"} />
            </div>
          )}
        </Container>
      </div>
    </div>
  );
};
export default RecuperarContraseña;
